module.exports = __webpack_public_path__ + "static/media/vitapark-opti.ecaa900f.mp4";